import { createSelector } from 'reselect'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { selectActualsData } from './selectActualsData'
import { selectActualsType } from './selectActualsType'

export const selectActualsTypeWithDefault = createSelector(
  [selectActualsType, selectActualsData],
  (actualsType, { valueTypeDefault }): ActualsValueTypes => {
    const validTypes = Object.values(ActualsValueTypes).filter(
      (type) => type !== ActualsValueTypes.None
    )

    // Prefer the current UI measure, then the selected offering's mapped default.
    // Never substitute the first item of the available-measures list.
    return (
      validTypes.find((type) => type === actualsType) ??
      validTypes.find((type) => type === valueTypeDefault) ??
      ActualsValueTypes.None
    )
  }
)
